import React, { useState, useEffect } from "react";
import { scheduleConfig } from "Static/outboxConstant";
import CustomTooltip from "Components/common/CustomTooltip";
import OutboxUtils from "Utils/OutboxUtils";
import { Utils } from "Utils/utils";
import { MP_EVENT } from "Static/constant";
import { ReactComponent as ScheduledIconDate } from "Assets/svg/outbox/scheduledIconDate.svg";
import { DateUtils } from "Utils/DateUtils";

const EmailStatusButton = props => {
  const {
    status = "",
    scheduleCode = "",
    expectedScheduleDate = "",
    taskDue = "",
    ...remainingProps
  } = props || {};

  const [showDelayedTooltip, setShowDelayedTooltip] = useState(false);
  const emailStatus = OutboxUtils.getEmailStatus(status, scheduleCode);

  const { message: delayedMessage = "", reason: delayedReason = "" } =
    emailStatus === "delayed" &&
    OutboxUtils.getDelayedTooltip(
      scheduleCode,
      expectedScheduleDate,
      taskDue,
      remainingProps
    );

  useEffect(() => {
    if (emailStatus === "delayed") {
      Utils.mixpanelTrack(MP_EVENT.OUTBOX_DELAYED_VIEWED, {
        pageType: "Inbox",
        reason: delayedReason
      });
    }
  }, []);

  return (
    <div
      className="outboxEmailStatusWrapper"
      style={{
        color: `${scheduleConfig?.[emailStatus]?.color}`
      }}
      onMouseEnter={() =>
        emailStatus === "delayed" && setShowDelayedTooltip(true)
      }
      onMouseLeave={() =>
        emailStatus === "delayed" && setShowDelayedTooltip(false)
      }
    >
      {scheduleConfig?.[emailStatus]?.svg || ""}
      <span className="scheduledText">
        {scheduleConfig?.[emailStatus]?.label || emailStatus}
      </span>
      {emailStatus === "delayed" && showDelayedTooltip && (
        <CustomTooltip text={delayedMessage} />
      )}
    </div>
  );
};

const EmailScheduleDateAndTime = props => {
  const { taskDue = "", emailStatus = "" } = props;
  const { date = "", time = "" } = DateUtils.getFormattedDateAndTime(taskDue);
  const scheduledEmail = emailStatus?.toLowerCase() === "delayed";
  // Merged Date/Time cell: today shows the time, otherwise the date; the full
  // "date · time" is on hover. Frees a whole column for the message.
  const due = taskDue ? new Date(taskDue) : null;
  const isToday =
    due && !isNaN(due.getTime()) &&
    due.toDateString() === new Date().toDateString();
  return (
    <div
      className={`scheduledDate scheduledMerged ${
        scheduledEmail ? "scheduledEmail" : ""
      }`}
      title={date && time ? `${date} · ${time}` : date || time}
    >
      {scheduledEmail ? (
        <ScheduledIconDate />
      ) : (
        <i className="material-icons-outlined obDateIcon">
          {isToday ? "schedule" : "calendar_today"}
        </i>
      )}
      <div className="flexCenter">{isToday ? time : date}</div>
    </div>
  );
};

export { EmailStatusButton, EmailScheduleDateAndTime };
export default EmailStatusButton;
